<template>
  <div class="PostsWidget">
    <PostsWidgetModal :widgetKey="widgetKey" />
    <Posts 
      :posts="posts"
      @submitPost="submitPost($event)" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import Posts from './Posts'
import PostsWidgetModal from '@/components/Modals/PostsWidget'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'


export default {
  props: [ 'widgetKey' ],
  components: {
    PostsWidgetModal,
    Posts
  },
  data () {
    return {
      posts: []
    }
  },
  mounted() {
    // db.posts.data.deleteAll();
    this.loadPosts();
  },
  computed: {
    ...mapState([])
  },
  methods: {
    editTable () {
      eventBus.$emit('showEditPostModal');
    },
    loadPosts() {
      db.posts.data
        .getAllByRecord(this.widgetKey, (posts) => {
          this.posts = posts.sort((a, b) => b.date - a.date);
        })
    },
    submitPost(post) {
      post.record = this.widgetKey;
      db.posts.data.add(post).then((res) => this.loadPosts());
    }
  },
  beforeDestroy () {
  }
}
</script>
<style >
  .PostsWidget {
    background: white;
    padding: 10px;
  }
</style>
